import React, { createContext, useState, useEffect } from "react";
import { shouldUseDarkMode } from "../utils/darkModeSchedule";

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    // Initialize from localStorage or auto-schedule
    const savedPreference = localStorage.getItem('themePreference');
    if (savedPreference && savedPreference !== 'auto') {
      return savedPreference;
    }
    // Use scheduled theme if auto or no preference
    return shouldUseDarkMode() ? 'dark' : 'light';
  });

  const toggleTheme = () => {
    setTheme((prevTheme) => {
      const newTheme = prevTheme === "light" ? "dark" : "light";
      // Save manual preference - this overrides auto schedule
      localStorage.setItem('themePreference', newTheme);
      return newTheme;
    });
  };

  // Auto-schedule only if no manual preference is set
  useEffect(() => {
    const savedPreference = localStorage.getItem('themePreference');
    
    // Only apply auto-schedule if preference is 'auto' or not set
    if (!savedPreference || savedPreference === 'auto') {
      const checkSchedule = () => {
        const scheduledTheme = shouldUseDarkMode() ? 'dark' : 'light';
        if (scheduledTheme !== theme) {
          setTheme(scheduledTheme);
        }
      };
      
      checkSchedule();
      const interval = setInterval(checkSchedule, 60000); // Check every minute
      
      return () => clearInterval(interval);
    }
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
